import tocbot from "tocbot";

document.addEventListener("turbo:load", () => {
  const content = document.querySelector(".js-toc-content");
  if(!content) return;

  const existingToc = content.querySelector("#ez-toc-container, .ez-toc-container, .toc-container");
  if (existingToc) return;

  const headings = content.querySelectorAll("h2, h3");
  const headingMap = {};

  if (headings.length < 3) return;

  Array.prototype.forEach.call(headings, function (heading) {
    const id = heading.id ? heading.id : heading.innerText.trim();
    headingMap[id] = !isNaN(headingMap[id]) ? ++headingMap[id] : 0;
    if (headingMap[id]) {
      heading.id = id + "-" + headingMap[id];
    } else {
      heading.id = id;
    }
  });

  const firstH2 = content.querySelector("h2");
  if (!firstH2) return;

  firstH2.insertAdjacentHTML('beforebegin', '<div class="toc-container"><div class="toc-title">目次</div><div class="js-toc"></div></div>');

  tocbot.init({
    tocSelector: '.js-toc',
    contentSelector: '.js-toc-content',
    headingSelector: 'h2, h3',
    hasInnerContainers: true,
    collapseDepth: 6,
    orderedList: false,
    scrollSmooth: true,
    scrollSmoothDuration: 420,
    headingsOffset: 80,
    scrollSmoothOffset: -80
  });
});

document.addEventListener("turbo:before-cache", () => {
  tocbot.destroy();
});
